import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=d8ce7b60"
import script from "./CampaignsTable.vue?vue&type=script&lang=js"
export * from "./CampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=d8ce7b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports